<div class="frame-1">
  <div class="frame-4">
    <div class="text-wrapper-3">Check your email</div>
    <p class="no-worries-just-en">
      If the email exists in our database, you will receive an email with
      instructions on how to reset your password.
    </p>
    <p class="no-email">
      <a (click)="toggleIsClicked()">Didn't receive an email?</a>
    </p>
  </div>
</div>
